/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory } from './RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory';
import {
    RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryFromJSON,
    RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryFromJSONTyped,
    RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryToJSON,
} from './RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory';

/**
 * 
 * @export
 * @interface RecordingManualChangesResponseFieldsContributionsItemsInnerChanges
 */
export interface RecordingManualChangesResponseFieldsContributionsItemsInnerChanges {
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInnerChanges
     */
    dataCategory?: RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInnerChanges
     */
    sourceUrl?: RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory;
    /**
     * 
     * @type {RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory}
     * @memberof RecordingManualChangesResponseFieldsContributionsItemsInnerChanges
     */
    notes?: RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategory;
}

/**
 * Check if a given object implements the RecordingManualChangesResponseFieldsContributionsItemsInnerChanges interface.
 */
export function instanceOfRecordingManualChangesResponseFieldsContributionsItemsInnerChanges(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function RecordingManualChangesResponseFieldsContributionsItemsInnerChangesFromJSON(json: any): RecordingManualChangesResponseFieldsContributionsItemsInnerChanges {
    return RecordingManualChangesResponseFieldsContributionsItemsInnerChangesFromJSONTyped(json, false);
}

export function RecordingManualChangesResponseFieldsContributionsItemsInnerChangesFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecordingManualChangesResponseFieldsContributionsItemsInnerChanges {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'dataCategory': !exists(json, 'data_category') ? undefined : RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryFromJSON(json['data_category']),
        'sourceUrl': !exists(json, 'source_url') ? undefined : RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryFromJSON(json['source_url']),
        'notes': !exists(json, 'notes') ? undefined : RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryFromJSON(json['notes']),
    };
}

export function RecordingManualChangesResponseFieldsContributionsItemsInnerChangesToJSON(value?: RecordingManualChangesResponseFieldsContributionsItemsInnerChanges | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data_category': RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryToJSON(value.dataCategory),
        'source_url': RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryToJSON(value.sourceUrl),
        'notes': RecordingManualChangesResponseFieldsContributionsItemsInnerChangesDataCategoryToJSON(value.notes),
    };
}

